import React from 'react'

import BETTER_VERSION from '../img/better-version.jpg'
import MEDICAL from '../img/medical.jpg'

import ICONS_MAP from 'react-icons/lib/md/location-on'
import ICONS_PHONE from 'react-icons/lib/md/local-phone'
import ICONS_EMAIL from 'react-icons/lib/md/email'

import DR_OLSEN from "../img/dr_olsen.jpg"
import DR_GALLOWAY from "../img/dr_galloway.jpg"

import Services from '../__components/Services'

class IndexPage extends React.Component {
  render() {
    const today = new Date().getDay()
    return (
      <div>
        <div id="index-hero">
          <div className="bg">
            WATERVIEW
          </div>

          <div className="container">
            <div className="columns">
              <div className="column is-narrow">
                <img src={BETTER_VERSION} />
              </div>

              <div className="column content">
                <h1>
                  Trusted Medical Professionals,<br />Enhancing Your Natural Beauty
                </h1>

                <p>
                  All assessments and treatments to be performed by Drs Olsen and Galloway. The doctors have a combined 35 years of medical experience. They will take the time to listen to your concerns and develop a treatment plan.
                </p>

                {/* <p style={{ marginTop: '12px' }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.
                </p> */}
              </div>
            </div>
          </div>
        </div>

        <Services />

        <div id="index-hero">
          <div className="bg">
            MEDICAL
          </div>

          <div className="container">
            <div className="columns">
              <div className="column is-narrow">
                <img src={MEDICAL} />
              </div>

              <div className="column content">
                <h1>
                  Waterview<br />
                  Medical<br />
                </h1>

                <p>
                  Waterview Medical Rejuvenation is located at Waterview Medical Centre in beautiful downtown Burlington. This historic building has been renovated into a beautiful medical space. We are <b>located behind Burlington City Hall</b> and <b>free parking</b> is available.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container marginTop-60">
          <div className="columns">
            <div className="column">
              <div className="title-bar marginTop-30">
                <h4>
                  Meet the Doctors
                </h4>

                {/* <p>
                  All treatments and assessments are performed by Doctors.<span style={{ display: "block", marginTop: 30 }}>Drs’ Galloway and Olsen have a combined medical experience of over 30 years.  In addition, they have further accreditation in Neuromodulator Cosmetics and Hyaluronic Acid treatments, recognized by the College of Physicians and Surgeons of Ontario.</span>
                </p> */}
              </div>
            </div>
          </div>
        </div>

        <div className="container" id="team">
          <div className="columns marginTop-60">
            <div className="column photo">
              <img src={DR_OLSEN} />
            </div>

            <div className="column info">
              <h2>Dr. Kristina Olsen</h2>
              <p className="deg">H. BSc, MD, CCFP, FCFP</p>

              <p className="bio">
                Dr. Olsen graduated from McMaster Medical School in 1996.  She then completed her Residency in Family Medicine at McMaster University in 1998 and became a Fellow in Family Medicine in 2009.  She is also an Adjunct Assistant Clinical Professor at the Department of Family Medicine at McMaster University.
              </p>
            </div>
          </div>

          <div className="columns marginTop-30">
            <div className="column photo">
              <img src={DR_GALLOWAY} />
            </div>
            <div className="column info">
              <h2>Dr. Victoria Galloway</h2>
              <p className="deg">H.BSc, M.Sc, MD, CCFP</p>

              <p className="bio">
                Dr. Galloway completed her Masters in Human Biology at the University of Guelph in 1996.  She was awarded the E.E. Hunt student prize for her research, from the Human Biology Association in 1997.  She completed her medical training in 2002 at the University of Toronto and then her Residency in the Department of Family and Community Medicine at the University of Toronto in 2005.
              </p>
            </div>
          </div>
        </div>

        <div className="container marginTop-60" id="contacts">
          <div className="columns">
            <div className="column">
              <div className="title-bar marginTop-30">
                <h4>
                  Location & Contacts
                </h4>

                <p>
                  Please call for an appointment
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="map">
          <a href="https://goo.gl/maps/4WXYahNXM1L2" target="_blank">
          </a>
        </div>

        <div className="container" id="location">
          <div className="columns">
            <div className="column">
              <div className="columns marginTop-15">
                <div className="column is-half">
                  <p>
                    <ICONS_PHONE size={20} style={{ marginLeft: '-3px', marginRight: '7.5px' }} />
                    <a href="tel:2893373030">(289) 337 - 3030</a>
                  </p>

                  {/* <p className="marginTop-10">
                    <ICONS_FAX size={18} style={{ marginLeft: '-3px', marginRight: '7.5px' }} />
                    (289) 245 - 1486
                  </p> */}

                  <p className="marginTop-10">
                    <ICONS_EMAIL size={20} style={{ marginLeft: '-3px', marginRight: '7.5px' }} />
                    <a href="mailto:waterviewmedicalrejuvenation@gmail.com">waterviewmedicalrejuvenation@gmail.com</a>
                  </p>
                </div>

                <div className="column is-half">
                  <p>
                    <ICONS_MAP size={20} style={{ marginLeft: '-3px', marginRight: '7.5px' }} />
                    <a href="https://goo.gl/maps/4WXYahNXM1L2" target="_blank">464 Locust St. Burlington, ON, L7S 1V1</a>
                  </p>

                  <p>
                    <span style={{ marginRight: 25 }}></span>
                    <b>Free parking available</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js